import React, { useState, useEffect, useCallback, useRef, createContext, useContext } from 'react';
import { Routes, Route, Link, useParams, useLocation, useNavigate } from 'react-router-dom';
import HousePortalHome from './HousePortalHome';
import HousePortalSearch from './HousePortalSearch';
import HousePortalDetail from './HousePortalDetail';
import HousePortalChat from './HousePortalChat';
import HousePortalTour from './HousePortalTour';

// ═══════════════════════════════════════════════════════════
// API Base URL
// ═══════════════════════════════════════════════════════════
const getApiBaseUrl = () => {
  const hostname = window.location.hostname;
  const port = window.location.port;
  if (!port || port === '80' || port === '443') return `${window.location.protocol}//${hostname}`;
  if (port === '3000') return `http://${hostname}:8000`;
  return `http://${hostname}:${port}`;
};

export const API_BASE = getApiBaseUrl();

// ═══════════════════════════════════════════════════════════
// i18n Translations
// ═══════════════════════════════════════════════════════════
const TRANSLATIONS = {
  en: {
    nav: { home: 'Home', properties: 'Properties', office: 'Office Rent', homeSearch: 'Home Rent', concierge: 'AI Concierge', tours: 'Virtual Tours', about: 'About' },
    footer: {
      tagline: 'AI-Powered Luxury Property Search in Bangkok',
      quickLinks: 'Quick Links',
      contact: 'Contact Us',
      followUs: 'Follow Us',
      rights: 'All rights reserved.',
      poweredBy: 'Powered by HOUSE AI',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
    },
    chat: { title: 'AI Concierge', placeholder: 'Ask me anything about properties...', online: 'Online' },
  },
  th: {
    nav: { home: '\u0e2b\u0e19\u0e49\u0e32\u0e41\u0e23\u0e01', properties: '\u0e2d\u0e2a\u0e31\u0e07\u0e2b\u0e32\u0e23\u0e34\u0e21\u0e17\u0e23\u0e31\u0e1e\u0e22\u0e4c', office: '\u0e2a\u0e33\u0e19\u0e31\u0e01\u0e07\u0e32\u0e19\u0e40\u0e0a\u0e48\u0e32', homeSearch: '\u0e1a\u0e49\u0e32\u0e19\u0e40\u0e0a\u0e48\u0e32', concierge: 'AI \u0e17\u0e35\u0e48\u0e1b\u0e23\u0e36\u0e01\u0e29\u0e32', tours: '\u0e17\u0e31\u0e27\u0e23\u0e4c\u0e40\u0e2a\u0e21\u0e37\u0e2d\u0e19\u0e08\u0e23\u0e34\u0e07', about: '\u0e40\u0e01\u0e35\u0e48\u0e22\u0e27\u0e01\u0e31\u0e1a\u0e40\u0e23\u0e32' },
    footer: {
      tagline: '\u0e04\u0e49\u0e19\u0e2b\u0e32\u0e2d\u0e2a\u0e31\u0e07\u0e2b\u0e32\u0e23\u0e34\u0e21\u0e17\u0e23\u0e31\u0e1e\u0e22\u0e4c\u0e2b\u0e23\u0e39\u0e2b\u0e23\u0e32\u0e43\u0e19\u0e01\u0e23\u0e38\u0e07\u0e40\u0e17\u0e1e\u0e14\u0e49\u0e27\u0e22 AI',
      quickLinks: '\u0e25\u0e34\u0e07\u0e01\u0e4c\u0e14\u0e48\u0e27\u0e19',
      contact: '\u0e15\u0e34\u0e14\u0e15\u0e48\u0e2d\u0e40\u0e23\u0e32',
      followUs: '\u0e15\u0e34\u0e14\u0e15\u0e32\u0e21\u0e40\u0e23\u0e32',
      rights: '\u0e2a\u0e07\u0e27\u0e19\u0e25\u0e34\u0e02\u0e2a\u0e34\u0e17\u0e18\u0e34\u0e4c\u0e17\u0e31\u0e49\u0e07\u0e2b\u0e21\u0e14',
      poweredBy: '\u0e02\u0e31\u0e1a\u0e40\u0e04\u0e25\u0e37\u0e48\u0e2d\u0e19\u0e42\u0e14\u0e22 HOUSE AI',
      privacy: '\u0e19\u0e42\u0e22\u0e1a\u0e32\u0e22\u0e04\u0e27\u0e32\u0e21\u0e40\u0e1b\u0e47\u0e19\u0e2a\u0e48\u0e27\u0e19\u0e15\u0e31\u0e27',
      terms: '\u0e02\u0e49\u0e2d\u0e01\u0e33\u0e2b\u0e19\u0e14\u0e01\u0e32\u0e23\u0e43\u0e2b\u0e49\u0e1a\u0e23\u0e34\u0e01\u0e32\u0e23',
    },
    chat: { title: 'AI \u0e17\u0e35\u0e48\u0e1b\u0e23\u0e36\u0e01\u0e29\u0e32', placeholder: '\u0e16\u0e32\u0e21\u0e40\u0e23\u0e32\u0e40\u0e01\u0e35\u0e48\u0e22\u0e27\u0e01\u0e31\u0e1a\u0e2d\u0e2a\u0e31\u0e07\u0e2b\u0e32\u0e23\u0e34\u0e21\u0e17\u0e23\u0e31\u0e1e\u0e22\u0e4c...', online: '\u0e2d\u0e2d\u0e19\u0e44\u0e25\u0e19\u0e4c' },
  },
  zh: {
    nav: { home: '\u9996\u9801', properties: '\u623f\u7522\u5217\u8868', office: '\u8fa6\u516c\u5ba4\u79df\u8cc1', homeSearch: '\u4f4f\u5bb6\u79df\u5c4b', concierge: 'AI \u7ba1\u5bb6', tours: '\u865b\u64ec\u5c0e\u89bd', about: '\u95dc\u65bc\u6211\u5011' },
    footer: {
      tagline: 'AI \u9a45\u52d5\u7684\u66fc\u8c37\u8c6a\u83ef\u623f\u7522\u641c\u5c0b',
      quickLinks: '\u5feb\u901f\u9023\u7d50',
      contact: '\u806f\u7e6b\u6211\u5011',
      followUs: '\u95dc\u6ce8\u6211\u5011',
      rights: '\u7248\u6b0a\u6240\u6709',
      poweredBy: '\u7531 HOUSE AI \u63d0\u4f9b\u6280\u8853\u652f\u63f4',
      privacy: '\u96b1\u79c1\u653f\u7b56',
      terms: '\u670d\u52d9\u689d\u6b3e',
    },
    chat: { title: 'AI \u7ba1\u5bb6', placeholder: '\u8acb\u554f\u4efb\u4f55\u95dc\u65bc\u623f\u7522\u7684\u554f\u984c...', online: '\u5728\u7dda' },
  },
};

const LANG_OPTIONS = [
  { key: 'en', label: 'EN', flag: '\ud83c\uddfa\ud83c\uddf8' },
  { key: 'th', label: '\u0e44\u0e17\u0e22', flag: '\ud83c\uddf9\ud83c\udded' },
  { key: 'zh', label: '\u4e2d\u6587', flag: '\ud83c\uddf9\ud83c\uddfc' },
];

// ═══════════════════════════════════════════════════════════
// Portal Context
// ═══════════════════════════════════════════════════════════
export const PortalContext = createContext({});

export function usePortal() {
  return useContext(PortalContext);
}

// ═══════════════════════════════════════════════════════════
// Layout Component
// ═══════════════════════════════════════════════════════════
export default function HousePortalLayout() {
  const { slug } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [portalInfo, setPortalInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [lang, setLang] = useState('en');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [scrolled, setScrolled] = useState(false);
  const [chatWidgetOpen, setChatWidgetOpen] = useState(false);
  const [chatMessages, setChatMessages] = useState([]);
  const [chatInput, setChatInput] = useState('');
  const [chatSending, setChatSending] = useState(false);

  const t = TRANSLATIONS[lang] || TRANSLATIONS.en;

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  // Track portal page visit (for admin monitoring dashboard)
  const visitedPath = useRef('');
  useEffect(() => {
    if (location.pathname === visitedPath.current) return;
    visitedPath.current = location.pathname;
    const pageName = location.pathname.split('/').filter(Boolean).pop() || 'home';
    try {
      fetch(`${API_BASE}/api/v1/analytics/track`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ page: `house_portal:${pageName}`, token: slug }),
      }).catch(() => {});
    } catch {
      // tracking is best-effort; never block portal rendering
    }
  }, [location.pathname, slug]);

  // Fetch portal info
  useEffect(() => {
    const fetchInfo = async () => {
      try {
        const res = await fetch(`${API_BASE}/h/${slug}/info`);
        if (res.ok) {
          const data = await res.json();
          setPortalInfo(data);
        } else {
          setPortalInfo({ name: 'HOUSE AI', partner_name: 'Life Property', accent_color: '#e8363a' });
        }
      } catch {
        setPortalInfo({ name: 'HOUSE AI', partner_name: 'Life Property', accent_color: '#e8363a' });
      } finally {
        setLoading(false);
      }
    };
    fetchInfo();
  }, [slug]);

  const sendChatMessage = useCallback(async (msg) => {
    if (!msg.trim()) return;
    const userMsg = { role: 'user', content: msg, ts: Date.now() };
    setChatMessages(prev => [...prev, userMsg]);
    setChatInput('');
    setChatSending(true);
    try {
      const res = await fetch(`${API_BASE}/h/${slug}/chat`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: msg, conversation_history: chatMessages.map(m => ({ role: m.role, content: m.content })) }),
      });
      if (res.ok) {
        const data = await res.json();
        setChatMessages(prev => [...prev, { role: 'assistant', content: data.reply || data.message || 'I am here to help you find the perfect property!', ts: Date.now() }]);
      } else {
        setChatMessages(prev => [...prev, { role: 'assistant', content: 'I apologize for the inconvenience. Please try again or contact us directly.', ts: Date.now() }]);
      }
    } catch {
      setChatMessages(prev => [...prev, { role: 'assistant', content: 'I apologize for the inconvenience. Please try again or contact us directly.', ts: Date.now() }]);
    } finally {
      setChatSending(false);
    }
  }, [slug, chatMessages]);

  const portalCtx = {
    slug, portalInfo, lang, setLang, t, isMobile, API_BASE,
    chatMessages, setChatMessages, sendChatMessage,
  };

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: 48, height: 48, borderRadius: '50%',
            border: '3px solid rgba(255,255,255,0.2)',
            borderTopColor: '#d4a537',
            animation: 'houseSpinner 1s linear infinite',
            margin: '0 auto 16px',
          }} />
          <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 14, letterSpacing: 2, textTransform: 'uppercase' }}>Loading...</div>
          <style>{`@keyframes houseSpinner { to { transform: rotate(360deg); } }`}</style>
        </div>
      </div>
    );
  }

  const partnerName = portalInfo?.partner_name || 'Life Property';
  const basePath = `/h/${slug}`;

  const navLinks = [
    { to: basePath, label: t.nav.home },
    { to: `${basePath}/properties`, label: t.nav.properties },
    { to: `${basePath}/properties?mode=office`, label: t.nav.office },
    { to: `${basePath}/properties?mode=home`, label: t.nav.homeSearch },
    { to: `${basePath}/chat`, label: t.nav.concierge },
    { to: `${basePath}/about`, label: t.nav.about },
  ];

  const isActive = (path) => {
    if (path === basePath) return location.pathname === basePath || location.pathname === basePath + '/';
    return location.pathname.startsWith(path);
  };

  return (
    <PortalContext.Provider value={portalCtx}>
      <div style={{ minHeight: '100vh', fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif", color: '#1a1a2e' }}>

        {/* ─── Global Keyframes ─── */}
        <style>{`
          @keyframes housePulse { 0%, 100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(228,54,58,0.4); } 70% { transform: scale(1.05); box-shadow: 0 0 0 12px rgba(228,54,58,0); } }
          @keyframes houseFadeIn { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
          @keyframes houseSlideDown { from { opacity: 0; transform: translateY(-12px); } to { opacity: 1; transform: translateY(0); } }
          @keyframes houseFloat { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-6px); } }
          @keyframes houseGlow { 0%, 100% { box-shadow: 0 0 20px rgba(212,165,55,0.3); } 50% { box-shadow: 0 0 40px rgba(212,165,55,0.6); } }
          @keyframes houseTyping { 0% { opacity: 0.3; } 50% { opacity: 1; } 100% { opacity: 0.3; } }
          @keyframes houseGradient { 0% { background-position: 0% 50%; } 50% { background-position: 100% 50%; } 100% { background-position: 0% 50%; } }
          * { box-sizing: border-box; margin: 0; padding: 0; }
          html { scroll-behavior: smooth; }
          input, textarea, select, button { font-family: inherit; }
          ::selection { background: rgba(212,165,55,0.3); }
        `}</style>

        {/* ═══ NAVIGATION BAR ═══ */}
        <nav style={{
          position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000, height: 72,
          background: scrolled ? 'rgba(255,255,255,0.97)' : 'rgba(255,255,255,0.92)',
          backdropFilter: 'blur(24px)', WebkitBackdropFilter: 'blur(24px)',
          borderBottom: scrolled ? '1px solid rgba(26,26,46,0.08)' : '1px solid transparent',
          boxShadow: scrolled ? '0 4px 32px rgba(0,0,0,0.06)' : 'none',
          transition: 'all 0.3s ease',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: isMobile ? '0 16px' : '0 48px',
        }}>
          {/* Logo */}
          <Link to={basePath} style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{
              width: 40, height: 40, borderRadius: 10,
              background: 'linear-gradient(135deg, #1a1a2e, #0f3460)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              boxShadow: '0 2px 12px rgba(26,26,46,0.2)',
            }}>
              <span style={{ color: '#d4a537', fontSize: 18, fontWeight: 800 }}>H</span>
            </div>
            <div>
              <div style={{ fontSize: 18, fontWeight: 700, color: '#1a1a2e', lineHeight: 1.2, letterSpacing: -0.5 }}>HOUSE AI</div>
              <div style={{ fontSize: 11, color: '#888', fontWeight: 500, letterSpacing: 0.5 }}>{partnerName}</div>
            </div>
          </Link>

          {/* Desktop Nav */}
          {!isMobile && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              {navLinks.map(link => (
                <Link key={link.to} to={link.to} style={{
                  textDecoration: 'none',
                  padding: '8px 18px',
                  borderRadius: 24,
                  fontSize: 14,
                  fontWeight: isActive(link.to) ? 600 : 500,
                  color: isActive(link.to) ? '#1a1a2e' : '#666',
                  background: isActive(link.to) ? 'rgba(26,26,46,0.06)' : 'transparent',
                  transition: 'all 0.25s ease',
                  letterSpacing: 0.2,
                }}>
                  {link.label}
                </Link>
              ))}
            </div>
          )}

          {/* Right Side: Language + CTA */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            {/* Language Switcher */}
            <div style={{ position: 'relative' }}>
              <LangSwitcher lang={lang} setLang={setLang} isMobile={isMobile} />
            </div>

            {/* CTA Button */}
            {!isMobile && (
              <button
                onClick={() => navigate(`${basePath}/properties`)}
                style={{
                  background: 'linear-gradient(135deg, #e8363a, #c02a2e)',
                  color: '#fff',
                  border: 'none',
                  padding: '10px 24px',
                  borderRadius: 12,
                  fontSize: 14,
                  fontWeight: 600,
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 16px rgba(232,54,58,0.3)',
                  letterSpacing: 0.3,
                }}
                onMouseEnter={e => { e.target.style.transform = 'translateY(-1px)'; e.target.style.boxShadow = '0 6px 24px rgba(232,54,58,0.4)'; }}
                onMouseLeave={e => { e.target.style.transform = 'translateY(0)'; e.target.style.boxShadow = '0 4px 16px rgba(232,54,58,0.3)'; }}
              >
                {t.nav.properties}
              </button>
            )}

            {/* Mobile Hamburger */}
            {isMobile && (
              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                style={{
                  background: 'none', border: 'none', cursor: 'pointer', padding: 8,
                  display: 'flex', flexDirection: 'column', gap: 5, justifyContent: 'center',
                }}
              >
                <span style={{ display: 'block', width: 24, height: 2, background: '#1a1a2e', borderRadius: 2, transition: 'all 0.3s', transform: mobileMenuOpen ? 'rotate(45deg) translate(5px, 5px)' : 'none' }} />
                <span style={{ display: 'block', width: 24, height: 2, background: '#1a1a2e', borderRadius: 2, transition: 'all 0.3s', opacity: mobileMenuOpen ? 0 : 1 }} />
                <span style={{ display: 'block', width: 24, height: 2, background: '#1a1a2e', borderRadius: 2, transition: 'all 0.3s', transform: mobileMenuOpen ? 'rotate(-45deg) translate(5px, -5px)' : 'none' }} />
              </button>
            )}
          </div>
        </nav>

        {/* ═══ MOBILE MENU ═══ */}
        {isMobile && mobileMenuOpen && (
          <div style={{
            position: 'fixed', top: 72, left: 0, right: 0, bottom: 0, zIndex: 999,
            background: 'rgba(255,255,255,0.98)', backdropFilter: 'blur(20px)',
            animation: 'houseSlideDown 0.25s ease',
            display: 'flex', flexDirection: 'column', padding: '24px',
          }}>
            {navLinks.map((link, i) => (
              <Link key={link.to} to={link.to} style={{
                textDecoration: 'none',
                padding: '18px 0',
                fontSize: 22, fontWeight: 600,
                color: isActive(link.to) ? '#e8363a' : '#1a1a2e',
                borderBottom: '1px solid rgba(0,0,0,0.06)',
                animation: `houseFadeIn 0.3s ease ${i * 0.05}s both`,
              }}>
                {link.label}
              </Link>
            ))}
            <button
              onClick={() => { navigate(`${basePath}/properties`); setMobileMenuOpen(false); }}
              style={{
                marginTop: 24, background: 'linear-gradient(135deg, #e8363a, #c02a2e)',
                color: '#fff', border: 'none', padding: '16px', borderRadius: 12,
                fontSize: 16, fontWeight: 600, cursor: 'pointer', textAlign: 'center',
              }}
            >
              {t.nav.properties}
            </button>
          </div>
        )}

        {/* ═══ MAIN CONTENT ═══ */}
        <main style={{ paddingTop: 72, minHeight: '100vh' }}>
          <Routes>
            <Route index element={<HousePortalHome />} />
            <Route path="properties" element={<HousePortalSearch />} />
            <Route path="properties/:propertyId" element={<HousePortalDetail />} />
            <Route path="property/:propertyId" element={<HousePortalDetail />} />
            <Route path="chat" element={<HousePortalChat />} />
            <Route path="tour/:tourId" element={<HousePortalTour />} />
            <Route path="*" element={<HousePortalHome />} />
          </Routes>
        </main>

        {/* ═══ FOOTER ═══ */}
        <footer style={{
          background: 'linear-gradient(180deg, #1a1a2e 0%, #0d0d1a 100%)',
          color: 'rgba(255,255,255,0.85)',
          padding: isMobile ? '48px 24px 24px' : '72px 48px 32px',
        }}>
          <div style={{
            maxWidth: 1200, margin: '0 auto',
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : '2fr 1fr 1fr 1fr',
            gap: isMobile ? 36 : 48,
          }}>
            {/* Brand Column */}
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
                <div style={{
                  width: 36, height: 36, borderRadius: 8,
                  background: 'linear-gradient(135deg, #d4a537, #f0c75e)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                  <span style={{ color: '#1a1a2e', fontSize: 16, fontWeight: 800 }}>H</span>
                </div>
                <span style={{ fontSize: 20, fontWeight: 700, letterSpacing: -0.5 }}>HOUSE AI</span>
              </div>
              <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 14, lineHeight: 1.7, marginBottom: 20, maxWidth: 320 }}>
                {t.footer.tagline}
              </p>
              <div style={{ display: 'flex', gap: 12 }}>
                {['facebook', 'instagram', 'line', 'youtube'].map(social => (
                  <div key={social} style={{
                    width: 36, height: 36, borderRadius: '50%',
                    background: 'rgba(255,255,255,0.08)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    cursor: 'pointer', transition: 'all 0.3s ease',
                    fontSize: 14, color: 'rgba(255,255,255,0.6)',
                  }}
                  onMouseEnter={e => { e.currentTarget.style.background = '#d4a537'; e.currentTarget.style.color = '#1a1a2e'; }}
                  onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.08)'; e.currentTarget.style.color = 'rgba(255,255,255,0.6)'; }}
                  >
                    {social[0].toUpperCase()}
                  </div>
                ))}
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 style={{ fontSize: 14, fontWeight: 600, marginBottom: 16, color: '#d4a537', textTransform: 'uppercase', letterSpacing: 1 }}>{t.footer.quickLinks}</h4>
              {navLinks.map(link => (
                <Link key={link.to} to={link.to} style={{
                  display: 'block', textDecoration: 'none', color: 'rgba(255,255,255,0.55)',
                  fontSize: 14, padding: '6px 0', transition: 'color 0.2s',
                }}
                onMouseEnter={e => e.target.style.color = '#fff'}
                onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.55)'}
                >
                  {link.label}
                </Link>
              ))}
            </div>

            {/* Contact */}
            <div>
              <h4 style={{ fontSize: 14, fontWeight: 600, marginBottom: 16, color: '#d4a537', textTransform: 'uppercase', letterSpacing: 1 }}>{t.footer.contact}</h4>
              <p style={{ color: 'rgba(255,255,255,0.55)', fontSize: 14, lineHeight: 2 }}>
                {partnerName}<br />
                Bangkok, Thailand<br />
                info@{slug || 'house'}.ai<br />
                +66 2 XXX XXXX
              </p>
            </div>

            {/* Legal */}
            <div>
              <h4 style={{ fontSize: 14, fontWeight: 600, marginBottom: 16, color: '#d4a537', textTransform: 'uppercase', letterSpacing: 1 }}>Legal</h4>
              <p style={{ color: 'rgba(255,255,255,0.55)', fontSize: 14, lineHeight: 2, cursor: 'pointer' }}>
                {t.footer.privacy}<br />
                {t.footer.terms}
              </p>
            </div>
          </div>

          <div style={{
            maxWidth: 1200, margin: '0 auto',
            borderTop: '1px solid rgba(255,255,255,0.08)',
            marginTop: 48, paddingTop: 24,
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'space-between',
            alignItems: isMobile ? 'center' : 'center',
            gap: 12,
          }}>
            <span style={{ color: 'rgba(255,255,255,0.3)', fontSize: 13 }}>
              &copy; {new Date().getFullYear()} {partnerName}. {t.footer.rights}
            </span>
            <span style={{ color: 'rgba(255,255,255,0.25)', fontSize: 12 }}>
              {t.footer.poweredBy}
            </span>
          </div>
        </footer>

        {/* ═══ FLOATING AI CHAT WIDGET ═══ */}
        {!location.pathname.includes('/chat') && (
          <>
            {/* Mini Chat Window */}
            {chatWidgetOpen && (
              <div style={{
                position: 'fixed', bottom: 100, right: 24, zIndex: 1001,
                width: isMobile ? 'calc(100vw - 32px)' : 380,
                height: 480,
                background: '#fff',
                borderRadius: 20,
                boxShadow: '0 12px 48px rgba(0,0,0,0.15)',
                display: 'flex', flexDirection: 'column',
                overflow: 'hidden',
                animation: 'houseFadeIn 0.3s ease',
              }}>
                {/* Chat Header */}
                <div style={{
                  background: 'linear-gradient(135deg, #1a1a2e, #0f3460)',
                  padding: '16px 20px',
                  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <div style={{
                      width: 36, height: 36, borderRadius: '50%',
                      background: 'linear-gradient(135deg, #d4a537, #f0c75e)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      fontSize: 16, fontWeight: 700, color: '#1a1a2e',
                    }}>AI</div>
                    <div>
                      <div style={{ color: '#fff', fontSize: 14, fontWeight: 600 }}>{t.chat.title}</div>
                      <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: 11, display: 'flex', alignItems: 'center', gap: 4 }}>
                        <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#52c41a', display: 'inline-block' }} />
                        {t.chat.online}
                      </div>
                    </div>
                  </div>
                  <button onClick={() => setChatWidgetOpen(false)} style={{
                    background: 'rgba(255,255,255,0.1)', border: 'none', color: '#fff',
                    width: 28, height: 28, borderRadius: '50%', cursor: 'pointer',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16,
                  }}>&times;</button>
                </div>

                {/* Messages */}
                <div style={{ flex: 1, overflowY: 'auto', padding: '16px', display: 'flex', flexDirection: 'column', gap: 12 }}>
                  {chatMessages.length === 0 && (
                    <div style={{
                      background: 'rgba(26,26,46,0.04)', borderRadius: 16, padding: '14px 16px',
                      fontSize: 14, color: '#555', lineHeight: 1.6, maxWidth: '85%',
                    }}>
                      Hello! I'm your AI Property Concierge. How can I help you today?
                    </div>
                  )}
                  {chatMessages.map((msg, i) => (
                    <div key={i} style={{
                      alignSelf: msg.role === 'user' ? 'flex-end' : 'flex-start',
                      background: msg.role === 'user' ? 'linear-gradient(135deg, #e8363a, #c02a2e)' : 'rgba(26,26,46,0.04)',
                      color: msg.role === 'user' ? '#fff' : '#333',
                      borderRadius: 16,
                      padding: '12px 16px',
                      fontSize: 14, lineHeight: 1.5,
                      maxWidth: '85%',
                      animation: 'houseFadeIn 0.3s ease',
                    }}>
                      {msg.content}
                    </div>
                  ))}
                  {chatSending && (
                    <div style={{ display: 'flex', gap: 4, padding: '8px 16px' }}>
                      {[0, 1, 2].map(i => (
                        <span key={i} style={{
                          width: 8, height: 8, borderRadius: '50%', background: '#ccc',
                          animation: `houseTyping 1s ease ${i * 0.15}s infinite`,
                        }} />
                      ))}
                    </div>
                  )}
                </div>

                {/* Input */}
                <div style={{ padding: '12px 16px', borderTop: '1px solid rgba(0,0,0,0.06)', display: 'flex', gap: 8 }}>
                  <input
                    value={chatInput}
                    onChange={e => setChatInput(e.target.value)}
                    onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendChatMessage(chatInput); } }}
                    placeholder={t.chat.placeholder}
                    style={{
                      flex: 1, border: '1px solid rgba(0,0,0,0.08)', borderRadius: 24,
                      padding: '10px 16px', fontSize: 14, outline: 'none',
                      background: 'rgba(0,0,0,0.02)', transition: 'border-color 0.2s',
                    }}
                    onFocus={e => e.target.style.borderColor = '#d4a537'}
                    onBlur={e => e.target.style.borderColor = 'rgba(0,0,0,0.08)'}
                  />
                  <button
                    onClick={() => sendChatMessage(chatInput)}
                    disabled={chatSending || !chatInput.trim()}
                    style={{
                      width: 40, height: 40, borderRadius: '50%',
                      background: chatInput.trim() ? 'linear-gradient(135deg, #e8363a, #c02a2e)' : '#ddd',
                      border: 'none', color: '#fff', cursor: chatInput.trim() ? 'pointer' : 'default',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      fontSize: 16, transition: 'all 0.2s',
                    }}
                  >
                    &#10148;
                  </button>
                </div>
              </div>
            )}

            {/* Floating Button */}
            <button
              onClick={() => setChatWidgetOpen(!chatWidgetOpen)}
              style={{
                position: 'fixed', bottom: 24, right: 24, zIndex: 1001,
                width: 60, height: 60, borderRadius: '50%',
                background: 'linear-gradient(135deg, #e8363a, #c02a2e)',
                border: 'none', color: '#fff',
                cursor: 'pointer',
                boxShadow: '0 6px 24px rgba(232,54,58,0.4)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 24,
                animation: chatWidgetOpen ? 'none' : 'housePulse 2s ease infinite',
                transition: 'all 0.3s ease',
              }}
              onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.1)'; }}
              onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; }}
            >
              {chatWidgetOpen ? '\u2715' : '\ud83d\udcac'}
            </button>
          </>
        )}
      </div>
    </PortalContext.Provider>
  );
}

// ═══════════════════════════════════════════════════════════
// Language Switcher Sub-Component
// ═══════════════════════════════════════════════════════════
function LangSwitcher({ lang, setLang, isMobile }) {
  const [open, setOpen] = useState(false);

  return (
    <div style={{ position: 'relative' }}>
      <button
        onClick={() => setOpen(!open)}
        style={{
          background: 'rgba(26,26,46,0.04)',
          border: '1px solid rgba(26,26,46,0.08)',
          borderRadius: 8,
          padding: '6px 12px',
          fontSize: 13,
          fontWeight: 500,
          cursor: 'pointer',
          display: 'flex', alignItems: 'center', gap: 6,
          color: '#555',
          transition: 'all 0.2s',
        }}
      >
        {LANG_OPTIONS.find(l => l.key === lang)?.flag} {LANG_OPTIONS.find(l => l.key === lang)?.label}
        <span style={{ fontSize: 10, opacity: 0.5 }}>&#9660;</span>
      </button>
      {open && (
        <div style={{
          position: 'absolute', top: '100%', right: 0, marginTop: 6,
          background: '#fff',
          borderRadius: 12,
          boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
          overflow: 'hidden',
          animation: 'houseFadeIn 0.2s ease',
          minWidth: 120,
          zIndex: 1010,
        }}>
          {LANG_OPTIONS.map(opt => (
            <button
              key={opt.key}
              onClick={() => { setLang(opt.key); setOpen(false); }}
              style={{
                display: 'block', width: '100%', textAlign: 'left',
                background: lang === opt.key ? 'rgba(212,165,55,0.1)' : 'transparent',
                border: 'none', padding: '10px 16px',
                fontSize: 14, cursor: 'pointer',
                color: lang === opt.key ? '#d4a537' : '#333',
                fontWeight: lang === opt.key ? 600 : 400,
                transition: 'background 0.2s',
              }}
              onMouseEnter={e => { if (lang !== opt.key) e.target.style.background = 'rgba(0,0,0,0.03)'; }}
              onMouseLeave={e => { if (lang !== opt.key) e.target.style.background = 'transparent'; }}
            >
              {opt.flag} {opt.label}
            </button>
          ))}
        </div>
      )}
      {open && <div onClick={() => setOpen(false)} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1009 }} />}
    </div>
  );
}
